var chunkMapping = {
	"src_bootstrap_js-webpack_sharing_consume_default_react-dom_react-dom": [
		71287,
		36264,
		3764,
		10971,
		37754,
		58042,
		97002,
		53572
	]
};
var idToExternalAndNameMapping = {
	"3764": [
		"default",
		"./routes",
		54260
	],
	"10971": [
		"default",
		"./routes",
		38595
	],
	"36264": [
		"default",
		"./reducer",
		38595
	],
	"37754": [
		"default",
		"./navigation",
		54260
	],
	"53572": [
		"default",
		"./register",
		38595
	],
	"58042": [
		"default",
		"./navigation",
		38595
	],
	"71287": [
		"default",
		"./reducer",
		54260
	],
	"97002": [
		"default",
		"./register",
		54260
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_modules__[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_modules__[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}